import Accordion from 'accordion-js';

export default function accordion(){
  const accordions = Array.from(document.querySelectorAll('.accordion-container'));
  new Accordion(accordions, {
    duration: 400
  });
}